// extracted by mini-css-extract-plugin
export default {"agreement":"info_agreement__Qv4ER","header":"info_header__pTDP6","body":"info_body__lxyVx"};